const eventImageDirOptions = [
    {directoryName: "friends", friendList: ["Cindy", "Charlie", "Jennifer", "Cameron"]},
    {directoryName: "friendThrifty", friendList: ["Cindy", "Charlie"]},
    {directoryName: "friendSpender", friendList: ["Jennifer", "Cameron"]}
]
export default eventImageDirOptions;